function activateMobileOverlays() {
  const cards = document.querySelectorAll('.overlay-hover');
  let activeCard = null;
  let isMobileActive = false;

  function updateVisibility() {
    const viewportCenter = window.innerHeight / 2;
    let closestCard = null;
    let closestDistance = Infinity;

    cards.forEach(card => {
      const rect = card.getBoundingClientRect();
      const cardCenter = rect.top + rect.height / 2;
      const distance = Math.abs(viewportCenter - cardCenter);

      if (
        distance < closestDistance &&
        rect.top >= 0 &&
        rect.bottom <= window.innerHeight
      ) {
        closestDistance = distance;
        closestCard = card;
      }
    });

    cards.forEach(card => {
      card.classList.remove('is-visible');
    });

    if (closestCard) {
      closestCard.classList.add('is-visible');
    }
  }

  function enableMobileMode() {
    if (!isMobileActive) {
      isMobileActive = true;
      window.addEventListener('scroll', updateVisibility, { passive: true });
      updateVisibility();
    }
  }

  function disableMobileMode() {
    if (isMobileActive) {
      isMobileActive = false;
      window.removeEventListener('scroll', updateVisibility);
      cards.forEach(card => card.classList.remove('is-visible'));
    }
  }

  function checkMode() {
    if (window.innerWidth < 768) {
      enableMobileMode();
    } else {
      disableMobileMode();
    }
  }

  // Initial setup
  checkMode();
  window.addEventListener('resize', checkMode);
}

document.addEventListener('DOMContentLoaded', activateMobileOverlays);
